// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a2-mu-xs {
  padding: 0 !important;
  min-height: 41px;
}
.a2-mu-xs-mappature {
  padding: 0 !important;
  min-height: 40px;
}
.a2-mu-xs-Esight{
  padding: 0 !important;
  min-height: 40px;
  border-color: grey;
}
.a2-mu-xs-Esight-Success{
  padding: 0 !important;
  min-height: 40px;
  border-color: rgb(35,198,171)
}
.a2-mu-xs-Esight-Warning{
  padding: 0 !important;
  min-height: 40px;
  border-color: red;
}
.a2-mu-xs-3 {
  padding: 0 !important;
  min-height: 41px;
  border-color: red;
}
.a2-mu-xs-Ecm-Success {
  padding: 0 !important;
  min-height: 41px;
  border-color: rgb(39,168,68);
}
.a2-mu-xs-2 {
  padding: 0 !important;
  min-height: 60px;
  border-color: rgb(39,168,68);
  border-width: 2px;
}

:host ::ng-deep .lilo .selected-list .c-btn {
 
 padding: 5px 40px 5px 5px;
 height: 39px;
}
:host ::ng-deep .lilo2 .selected-list .c-btn {
 
  padding: 5px 40px 5px 5px;
  height: 56px;
 }
 @media screen and (max-width: 789px){

  :host ::ng-deep .lilo3 .selected-list .c-btn {
 
    padding: 5px 40px 5px 5px;
    height: 56px;
   }
   .a2-mu-xs-Esight-Success{
    padding: 0 !important;
    min-height: 60px;
    border-color: rgb(35,198,171);
    border-width: 2px;
  }
  .a2-mu-xs-Esight{
    padding: 0 !important;
    min-height: 60px;
    border-color: grey;
    border-width: 2px;
  }
  .a2-mu-xs-Esight-Warning{
    padding: 0 !important;
    min-height: 60px;
    border-color: red;
    border-width: 2px;

  } 

 }
 @media screen and (max-width: 1000px){
  :host ::ng-deep .lilo2 .selected-list .c-btn {
 
    padding: 5px 40px 5px 5px;
    height: 83px;
   }
  .a2-mu-xs-2 {
    padding: 0 !important;
    min-height: 87px;
    border-color: rgb(39,168,68);
    border-width: 2px;
  }
 }
 :host ::ng-deep .area-container .selected-list .c-btn {
 
  padding: 5px 40px 5px 5px;
  height: 39px;
  font-weight: bolder;
  padding-left: 12px;
  font-size: 16px;
 }
 .plus-btn:focus {
   border: 2px solid #4798e8;
   outline: none;
 }
 .top-line{
   top: 45px;
 }
 .top-line-2{
   top: 30px;
 }
 .margin-util{
  margin-bottom: 10px;
}
.position-2{
  display: flex; 
  position: relative; 
  margin-bottom: 15px;
}
.input-width{
  min-width: 100%;
}
.btn-position{
  border-style: none; 
  background: none; 
  right: -1%;
  position: relative; 
  z-index: 9;
}
.hold-div{
  display: flex;
}
@media only screen and (max-width: 375px) {
  .radio-width{
      width: 170px;
  }
  .radio-width-2{
    width: 175px;
  }
  .top-line{
    top: 99px;
  }
  .top-line-2{
    top: 68px;
  }
  .font-size{
    font-size: 12px;
  }
  .hold-div {
    display: block;
  }
}

@media only screen and (max-width: 767px) {


  .btn-position{
    right: 10%;   
  }
  .util-border{
    border-style: groove;
  }
  .top-line-2{
    top: 5px;
  }
  .margin-util{
    margin-bottom: 50px;
  }
  .top-line{
   top: -55px;
  }
  .position-1{
    position: relative;
    top: 135px;
    right: 108%;
  }
  .position-2{
    margin-bottom: 55px;
  }
  .input-width{
    min-width: 205%;
  }
 

}

@media only screen and (max-width: 370px) {

  .position-1{
    top: 193px;
    
  }
  

}
@media only screen and (max-width: 458px) {

  .top-line{
    top: -20px;
   }
  

}

@media only screen and (max-width: 378px) {

  .top-line{
    top: 5px;
   }
 
  

}


@media only screen and (max-width: 370px) {
 
  .top-line{
    top: -50px;
   }
  
  

}
@media only screen and (max-width: 620px) {

  .btn-position{
    right: 13%; 
   
  }
}
@media only screen and (max-width: 360px) {

  .btn-position{
    right: -1%; 
   
  }
}
@media only screen and (max-width: 960px) {

  .btn-position{
    right: 7%; 
    
  }
  

}
@media only screen and (max-width: 766px) {

  .btn-position{
    right: 12%; 
    
  }
  

}
@media only screen and (max-width: 540px) {

  .btn-position{
    right: 15%; 
    
  }
  

}
@media only screen and (max-width: 425px) {

  .btn-position{
    right: 18%; 
    
  }
  

}
@media only screen and (max-width: 379px) {

  .btn-position{
    right: 0%; 
    
  }
 
  

}
@media only screen and (max-width: 310px) {

  
  .top-line{
    right: 15px;
   }
   .font{
     font-size: 12px;
   }
  

}

.border-grey{
border-color: #e9ecef;
}
.border-red{
  border-color: #ef6e6e;
}



.error-tooltip{
  opacity: 0;
  background-color: #ef6e6e;
  color: #ffffff;
  padding: 3px 6px;
  border-radius: 3px;
  position: absolute;
  font-size: 13px;
  top: 5px;
  left: 50%;
  transform: translateX(-50%) translateY(10px);
  transition: .35s ease all;
}
.ng-invalid+.error-tooltip{
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}


@media screen and (max-width: 768px){
  .error-tooltip{
    width: 100%;
    font-size: 12px;
    top: -20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/richieste/area/area.component.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB;AACF;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;;CAEC,yBAAyB;CACzB,YAAY;AACb;AACA;;EAEE,yBAAyB;EACzB,YAAY;CACb;CACA;;EAEC;;IAEE,yBAAyB;IACzB,YAAY;GACb;GACA;IACC,qBAAqB;IACrB,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;;EAEnB;;CAED;CACA;EACC;;IAEE,yBAAyB;IACzB,YAAY;GACb;EACD;IACE,qBAAqB;IACrB,gBAAgB;IAChB,4BAA4B;IAC5B,iBAAiB;EACnB;CACD;CACA;;EAEC,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;CAChB;CACA;GACE,yBAAyB;GACzB,aAAa;CACf;CACA;GACE,SAAS;CACX;CACA;GACE,SAAS;CACX;CACA;EACC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE;MACI,YAAY;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;;;EAGE;IACE,UAAU;EACZ;EACA;IACE,oBAAoB;EACtB;EACA;IACE,QAAQ;EACV;EACA;IACE,mBAAmB;EACrB;EACA;GACC,UAAU;EACX;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;;;AAGF;;AAEA;;EAEE;IACE,UAAU;;EAEZ;;;AAGF;AACA;;EAEE;IACE,UAAU;GACX;;;AAGH;;AAEA;;EAEE;IACE,QAAQ;GACT;;;;AAIH;;;AAGA;;EAEE;IACE,UAAU;GACX;;;;AAIH;AACA;;EAEE;IACE,UAAU;;EAEZ;AACF;AACA;;EAEE;IACE,UAAU;;EAEZ;AACF;AACA;;EAEE;IACE,SAAS;;EAEX;;;AAGF;AACA;;EAEE;IACE,UAAU;;EAEZ;;;AAGF;AACA;;EAEE;IACE,UAAU;;EAEZ;;;AAGF;AACA;;EAEE;IACE,UAAU;;EAEZ;;;AAGF;AACA;;EAEE;IACE,SAAS;;EAEX;;;;AAIF;AACA;;;EAGE;IACE,WAAW;GACZ;GACA;KACE,eAAe;GACjB;;;AAGH;;AAEA;AACA,qBAAqB;AACrB;AACA;EACE,qBAAqB;AACvB;;;;AAIA;EACE,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,4CAA4C;EAC5C,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,yCAAyC;AAC3C;;;AAGA;EACE;IACE,WAAW;IACX,eAAe;IACf,UAAU;EACZ;AACF","sourcesContent":[".a2-mu-xs {\r\n  padding: 0 !important;\r\n  min-height: 41px;\r\n}\r\n.a2-mu-xs-mappature {\r\n  padding: 0 !important;\r\n  min-height: 40px;\r\n}\r\n.a2-mu-xs-Esight{\r\n  padding: 0 !important;\r\n  min-height: 40px;\r\n  border-color: grey;\r\n}\r\n.a2-mu-xs-Esight-Success{\r\n  padding: 0 !important;\r\n  min-height: 40px;\r\n  border-color: rgb(35,198,171)\r\n}\r\n.a2-mu-xs-Esight-Warning{\r\n  padding: 0 !important;\r\n  min-height: 40px;\r\n  border-color: red;\r\n}\r\n.a2-mu-xs-3 {\r\n  padding: 0 !important;\r\n  min-height: 41px;\r\n  border-color: red;\r\n}\r\n.a2-mu-xs-Ecm-Success {\r\n  padding: 0 !important;\r\n  min-height: 41px;\r\n  border-color: rgb(39,168,68);\r\n}\r\n.a2-mu-xs-2 {\r\n  padding: 0 !important;\r\n  min-height: 60px;\r\n  border-color: rgb(39,168,68);\r\n  border-width: 2px;\r\n}\r\n\r\n:host ::ng-deep .lilo .selected-list .c-btn {\r\n \r\n padding: 5px 40px 5px 5px;\r\n height: 39px;\r\n}\r\n:host ::ng-deep .lilo2 .selected-list .c-btn {\r\n \r\n  padding: 5px 40px 5px 5px;\r\n  height: 56px;\r\n }\r\n @media screen and (max-width: 789px){\r\n\r\n  :host ::ng-deep .lilo3 .selected-list .c-btn {\r\n \r\n    padding: 5px 40px 5px 5px;\r\n    height: 56px;\r\n   }\r\n   .a2-mu-xs-Esight-Success{\r\n    padding: 0 !important;\r\n    min-height: 60px;\r\n    border-color: rgb(35,198,171);\r\n    border-width: 2px;\r\n  }\r\n  .a2-mu-xs-Esight{\r\n    padding: 0 !important;\r\n    min-height: 60px;\r\n    border-color: grey;\r\n    border-width: 2px;\r\n  }\r\n  .a2-mu-xs-Esight-Warning{\r\n    padding: 0 !important;\r\n    min-height: 60px;\r\n    border-color: red;\r\n    border-width: 2px;\r\n\r\n  } \r\n\r\n }\r\n @media screen and (max-width: 1000px){\r\n  :host ::ng-deep .lilo2 .selected-list .c-btn {\r\n \r\n    padding: 5px 40px 5px 5px;\r\n    height: 83px;\r\n   }\r\n  .a2-mu-xs-2 {\r\n    padding: 0 !important;\r\n    min-height: 87px;\r\n    border-color: rgb(39,168,68);\r\n    border-width: 2px;\r\n  }\r\n }\r\n :host ::ng-deep .area-container .selected-list .c-btn {\r\n \r\n  padding: 5px 40px 5px 5px;\r\n  height: 39px;\r\n  font-weight: bolder;\r\n  padding-left: 12px;\r\n  font-size: 16px;\r\n }\r\n .plus-btn:focus {\r\n   border: 2px solid #4798e8;\r\n   outline: none;\r\n }\r\n .top-line{\r\n   top: 45px;\r\n }\r\n .top-line-2{\r\n   top: 30px;\r\n }\r\n .margin-util{\r\n  margin-bottom: 10px;\r\n}\r\n.position-2{\r\n  display: flex; \r\n  position: relative; \r\n  margin-bottom: 15px;\r\n}\r\n.input-width{\r\n  min-width: 100%;\r\n}\r\n.btn-position{\r\n  border-style: none; \r\n  background: none; \r\n  right: -1%;\r\n  position: relative; \r\n  z-index: 9;\r\n}\r\n.hold-div{\r\n  display: flex;\r\n}\r\n@media only screen and (max-width: 375px) {\r\n  .radio-width{\r\n      width: 170px;\r\n  }\r\n  .radio-width-2{\r\n    width: 175px;\r\n  }\r\n  .top-line{\r\n    top: 99px;\r\n  }\r\n  .top-line-2{\r\n    top: 68px;\r\n  }\r\n  .font-size{\r\n    font-size: 12px;\r\n  }\r\n  .hold-div {\r\n    display: block;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 767px) {\r\n\r\n\r\n  .btn-position{\r\n    right: 10%;   \r\n  }\r\n  .util-border{\r\n    border-style: groove;\r\n  }\r\n  .top-line-2{\r\n    top: 5px;\r\n  }\r\n  .margin-util{\r\n    margin-bottom: 50px;\r\n  }\r\n  .top-line{\r\n   top: -55px;\r\n  }\r\n  .position-1{\r\n    position: relative;\r\n    top: 135px;\r\n    right: 108%;\r\n  }\r\n  .position-2{\r\n    margin-bottom: 55px;\r\n  }\r\n  .input-width{\r\n    min-width: 205%;\r\n  }\r\n \r\n\r\n}\r\n\r\n@media only screen and (max-width: 370px) {\r\n\r\n  .position-1{\r\n    top: 193px;\r\n    \r\n  }\r\n  \r\n\r\n}\r\n@media only screen and (max-width: 458px) {\r\n\r\n  .top-line{\r\n    top: -20px;\r\n   }\r\n  \r\n\r\n}\r\n\r\n@media only screen and (max-width: 378px) {\r\n\r\n  .top-line{\r\n    top: 5px;\r\n   }\r\n \r\n  \r\n\r\n}\r\n\r\n\r\n@media only screen and (max-width: 370px) {\r\n \r\n  .top-line{\r\n    top: -50px;\r\n   }\r\n  \r\n  \r\n\r\n}\r\n@media only screen and (max-width: 620px) {\r\n\r\n  .btn-position{\r\n    right: 13%; \r\n   \r\n  }\r\n}\r\n@media only screen and (max-width: 360px) {\r\n\r\n  .btn-position{\r\n    right: -1%; \r\n   \r\n  }\r\n}\r\n@media only screen and (max-width: 960px) {\r\n\r\n  .btn-position{\r\n    right: 7%; \r\n    \r\n  }\r\n  \r\n\r\n}\r\n@media only screen and (max-width: 766px) {\r\n\r\n  .btn-position{\r\n    right: 12%; \r\n    \r\n  }\r\n  \r\n\r\n}\r\n@media only screen and (max-width: 540px) {\r\n\r\n  .btn-position{\r\n    right: 15%; \r\n    \r\n  }\r\n  \r\n\r\n}\r\n@media only screen and (max-width: 425px) {\r\n\r\n  .btn-position{\r\n    right: 18%; \r\n    \r\n  }\r\n  \r\n\r\n}\r\n@media only screen and (max-width: 379px) {\r\n\r\n  .btn-position{\r\n    right: 0%; \r\n    \r\n  }\r\n \r\n  \r\n\r\n}\r\n@media only screen and (max-width: 310px) {\r\n\r\n  \r\n  .top-line{\r\n    right: 15px;\r\n   }\r\n   .font{\r\n     font-size: 12px;\r\n   }\r\n  \r\n\r\n}\r\n\r\n.border-grey{\r\nborder-color: #e9ecef;\r\n}\r\n.border-red{\r\n  border-color: #ef6e6e;\r\n}\r\n\r\n\r\n\r\n.error-tooltip{\r\n  opacity: 0;\r\n  background-color: #ef6e6e;\r\n  color: #ffffff;\r\n  padding: 3px 6px;\r\n  border-radius: 3px;\r\n  position: absolute;\r\n  font-size: 13px;\r\n  top: 5px;\r\n  left: 50%;\r\n  transform: translateX(-50%) translateY(10px);\r\n  transition: .35s ease all;\r\n}\r\n.ng-invalid+.error-tooltip{\r\n  opacity: 1;\r\n  transform: translateX(-50%) translateY(0);\r\n}\r\n\r\n\r\n@media screen and (max-width: 768px){\r\n  .error-tooltip{\r\n    width: 100%;\r\n    font-size: 12px;\r\n    top: -20px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
